import { TransactionStatus } from "../../types/transaction";

export type BalanceChanges = Record<string, number>;

// What action is being performed
export enum AnalyticsTransactionType {
    LoopWind = 0,
    LoopUnwind = 1,
    VaultDeposit = 2,
    VaultWithdraw = 3,
    StrategyCreate = 4,
    LoanRepay = 5,
    CollateralDeposit = 6
}

// Base analytics info for all transactions
export interface AnalyticsInfo {
    transactionType?: AnalyticsTransactionType;
    transactionStatus?: TransactionStatus;
    simulation?: boolean; // true = simulation event, false/undefined = actual transaction event
    transactionIdentifier?: string;
    errorMessage?: string;
}

// Loop-specific analytics
export interface LoopAnalyticsInfo extends AnalyticsInfo {
    principalMint?: string;
    collateralMint?: string;
    principalSymbol?: string;
    collateralSymbol?: string;
    depositMint?: string;
    mintToReceive?: string;
    slippagePercentDecimals?: number;
    inputAmount?: number;
    outputAmount?: number;
    principalAmount?: number;

    loanAddress?: string;
    loopIdentifier?: string;
}

export interface VaultAnalyticsInfo extends AnalyticsInfo {
    vault?: string;
    principalAmount?: number;
    minLpAmount?: number;
    depositOnly?: boolean;
    amountPrincipal?: number;
    maxAmountLp?: number;
    withdrawAll?: boolean;
    withdrawOnly?: boolean;
}

export interface CollateralDepositAnalyticsInfo extends AnalyticsInfo {
    loanAddress?: string;
    depositMint?: string;
    amount?: number;
    assetType?: number;
    assetIdentifier?: string;
    hasUnstakeStep?: boolean;
}

export interface StrategyCreateAnalyticsInfo extends AnalyticsInfo {
    lender?: string;
    amount?: number;
    originationsEnabled?: boolean;
    liquidityBuffer?: number;
    interestFee?: number;
    originationFee?: number;
    originationCap?: number;
    marketInformation?: string;
    collateralTermCount?: number;
    hasExternalYieldSource?: boolean;
}

// Generic factory function that returns the correct analytics type
export function createAnalyticsInfo<T extends AnalyticsInfo = AnalyticsInfo>(params: Partial<T>): T {
    return params as T;
}
